import { BillingInfo } from '@sharefiledev/sharefile-appshell';

// Copied over from: https://code.sharefile-coretools.com/projects/WAPP/repos/sharefile-ui/browse/src/App/Workflows/CustomWorkflow/config.ts
const MAPSAPIKEYSTORAGEID = 'GoogleMapsApiKey';

export function getMapsApiKey(): string {
	return getFromSessionStorage<string>(MAPSAPIKEYSTORAGEID);
}

function getFromSessionStorage<T>(key: string, clear = false): T {
	return getFromStorage(sessionStorage, key, clear) as T;
}

function getFromStorage(dataStore: Storage, key: string, clear: boolean) {
	const data = dataStore.getItem(key);
	let obj: any;
	try {
		obj = JSON.parse(data ?? '');
	} catch (e) {
		obj = data;
	}
	if (clear) {
		clearFromStorage(dataStore, key);
	}
	return obj;
}

function clearFromStorage(dataStore: Storage, key: string) {
	dataStore.removeItem(key);
}

export function getPlaceDetails(
	placesService: google.maps.places.PlacesService,
	selectedValue: string,
	onAddressSelected: (address: BillingInfo) => void,
	onComplete: () => void,
	sessionToken?: google.maps.places.AutocompleteSessionToken
) {
	placesService.getDetails(
		{ placeId: selectedValue, sessionToken, fields: ['address_components'] },
		(
			place: google.maps.places.PlaceResult | null,
			status: google.maps.places.PlacesServiceStatus | null
		) => {
			if (status === google.maps.places.PlacesServiceStatus.OK && place) {
				const mappedPlace = mapPlaceResultToAddress(place.address_components);
				onAddressSelected(mappedPlace);
			} else {
				console.error('Error fetching place details:', status);
			}
			onComplete();
		}
	);
}

export function mapPlaceResultToAddress(
	googleAddress: google.maps.places.PlaceResult['address_components']
): BillingInfo {
	const location: BillingInfo = {};
	let streetNumber = '';
	let streetName = '';

	googleAddress?.forEach(
		(component: { types: string[]; short_name: string; long_name: string }) => {
			component.types.forEach((type: string) => {
				switch (type) {
					case 'country':
						location.Country = component.short_name; // Abbreviation (e.g., "US")
						break;
					case 'administrative_area_level_1':
						location.State = component.short_name ?? component.long_name; // Abbreviation (e.g., "CA")
						break;
					case 'locality':
					case 'postal_town':
						location.City = component.long_name;
						break;
					case 'postal_code':
						location.Zip = component.long_name;
						break;
					case 'street_number':
						streetNumber = component.long_name;
						break;
					case 'route':
						streetName = component.long_name;
						break;
					default:
						break;
				}
			});
		}
	);

	location.Address1 = `${streetNumber} ${streetName}`.trim(); // Order could differ; accepting that as a limitation for now

	return location;
}
